import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'SERVER_TYPES',
    itemActionName: 'SERVER_TYPE',
});
